/* import __COLOCATED_TEMPLATE__ from './appointments-subs-plans.hbs'; */
var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import * as WindowUtils from '@square/dashboard-utilities/utils/window';
import { feature } from '@square/ember-features/macros';
import { WorkflowState } from '@square/appointments-feature-upsell/constants';
import { APPOINTMENTS_FREE_TOKEN, APPOINTMENTS_PLUS_TOKEN, APPOINTMENTS_PREMIUM_TOKEN } from '@square/appointments-feature-upsell/services/appointments-feature-info';
let AppointmentsSubsPlansComponent = (_dec = feature('appointments/plan_selection_in_situation_subscriptions'), _class = class AppointmentsSubsPlansComponent extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "appointmentsFeatureInfo", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "features", _descriptor3, this);
    _initializerDefineProperty(this, "appointmentsSubscription", _descriptor4, this);
    _initializerDefineProperty(this, "dataApi", _descriptor5, this);
    _initializerDefineProperty(this, "appointmentsSubscriptionModal", _descriptor6, this);
    _initializerDefineProperty(this, "isComparePlansModalOpen", _descriptor7, this);
    _initializerDefineProperty(this, "showSubsPlans", _descriptor8, this);
    _initializerDefineProperty(this, "selectedPlan", _descriptor9, this);
    _initializerDefineProperty(this, "canSubscribeInSituation", _descriptor10, this);
    _defineProperty(this, "emphasizedPlanToken", APPOINTMENTS_PLUS_TOKEN);
    this.dataApi.track('Page', {
      platform: 'web',
      page_name: this.pageNameForCDPTracking,
      subscription_state: this.appointmentsSubscription.status,
      plan_token: this.appointmentsSubscription.planToken
    });
    if (this.appointmentsSubscription.countryCode) {
      this.appointmentsFeatureInfo.fetchFullFeatureLists(this.appointmentsSubscription.countryCode).catch(err => {
        this.dataApi.track('Error', {
          platform: 'web',
          page_name: this.pageNameForCDPTracking,
          subscription_state: this.appointmentsSubscription.status,
          plan_token: this.appointmentsSubscription.planToken,
          error: err
        });
      });
    }
  }
  get pillTextMap() {
    return {
      [APPOINTMENTS_FREE_TOKEN]: this.intl.t('apptsUpsell.subscription.pill.basic'),
      [APPOINTMENTS_PLUS_TOKEN]: this.intl.t('apptsUpsell.subscription.pill.value'),
      [APPOINTMENTS_PREMIUM_TOKEN]: this.intl.t('apptsUpsell.subscription.pill.complete')
    };
  }
  get featureListTitlesMap() {
    return {
      [APPOINTMENTS_FREE_TOKEN]: this.intl.t('apptsUpsell.subscription.plan.featuresHeader.free'),
      [APPOINTMENTS_PLUS_TOKEN]: this.intl.t('apptsUpsell.subscription.plan.featuresHeader.plus'),
      [APPOINTMENTS_PREMIUM_TOKEN]: this.intl.t('apptsUpsell.subscription.plan.featuresHeader.premium')
    };
  }
  get canManageSubscriptions() {
    return this.args.canManageSubscriptions ?? false;
  }

  // If true, will add the reload-user parameter when redirecting to the homepage
  get refetchUserAfterRedirect() {
    return this.args.refetchUserAfterRedirect ?? false;
  }
  get type() {
    return this.args.type ?? WorkflowState.DEFAULT;
  }
  get activeSubscriptionPlan() {
    return this.appointmentsSubscription.activeSubscriptionPlan();
  }
  get showComparePlans() {
    return this.appointmentsFeatureInfo.featureDataLoaded;
  }
  get subscriptionPlans() {
    let plans = this.appointmentsSubscription.getSubscriptionPlans();
    // Filter out Free plan if in the Upgrading flow and currently on a Paid plan
    if (this.type === WorkflowState.UPGRADING && this.activeSubscriptionPlan !== APPOINTMENTS_FREE_TOKEN) {
      plans = plans.filter(plan => plan.token !== APPOINTMENTS_FREE_TOKEN);
    }
    const visibilities = {};
    for (const plan of plans) {
      if (!this.canManageSubscriptions) {
        visibilities[plan.token] = false;
        continue;
      }
      visibilities[plan.token] = this.activeSubscriptionPlan !== plan.token;
    }
    const mappedPlans = [];
    for (const plan of plans) {
      const token = plan.token;
      const isActiveSubscription = this.activeSubscriptionPlan === token;
      const mappedPlan = {
        ...plan,
        pillText: isActiveSubscription ? this.intl.t('apptsUpsell.subscription.plan.currentSubscription') : this.pillTextMap[token],
        buttonText: this.buttonTextForPlan(plan),
        featureListTitle: this.featureListTitlesMap[token],
        isButtonVisible: visibilities[token],
        isEmphasized: token === this.emphasizedPlanToken,
        isActiveSubscription,
        canManageSubscriptions: this.canManageSubscriptions
      };
      mappedPlans.push(mappedPlan);
    }
    return mappedPlans;
  }

  // This is just needed for the CDP tracking
  get pageNameForCDPTracking() {
    switch (this.type) {
      case WorkflowState.MIGRATING:
        return 'appointments/subscription/choose_plan';
      case WorkflowState.ONBOARDING:
        return 'appointments-plan-selections';
      case WorkflowState.UNSUBSCRIBED:
        return '/appointments/subscription_plans_unsubscribed';
      default:
        return undefined;
    }
  }
  get title() {
    if (this.args.customTitle) {
      return this.args.customTitle;
    }
    switch (this.type) {
      case WorkflowState.UNSUBSCRIBED:
        return this.intl.t('apptsUpsell.subscription.plans.unsubscribed.title');
      case WorkflowState.UPGRADING:
        return this.intl.t('apptsUpsell.subscription.plans.upgrading.title');
      default:
        return this.intl.t('apptsUpsell.planSelection.title');
    }
  }
  get subtitle() {
    switch (this.type) {
      case WorkflowState.UNSUBSCRIBED:
        return this.intl.t('apptsUpsell.subscription.plans.unsubscribed.subtitle');
      default:
        return this.intl.t('apptsUpsell.planSelection.subtitle');
    }
  }
  buttonTextForPlan(plan) {
    if (this.type === WorkflowState.ONBOARDING) {
      return this.intl.t('apptsUpsell.common.getStarted');
    }
    if (plan.freeTrialDaysLeft > 0) {
      return this.intl.t('apptsUpsell.subscription.startFreeTrial');
    }
    if (plan.isFree) {
      return this.intl.t('apptsUpsell.common.getStarted');
    }
    return this.appointmentsSubscription.isPlanUpgrade(plan) ? this.intl.t('apptsUpsell.common.upgrade') : this.intl.t('apptsUpsell.common.getStarted');
  }
  selectPlanHandler(plan) {
    if (this.args.selectPlan) {
      this.args.selectPlan(plan);
    } else if (this.canSubscribeInSituation) {
      this.appointmentsSubscriptionModal.open({
        planToken: plan.token,
        subscriptionToken: this.appointmentsSubscription.token,
        primaryBusinessLocation: this.args.primaryBusinessLocation
      }).then(({
        didSubscribe
      }) => {
        if (didSubscribe) {
          let url = '/dashboard/appointments';
          const params = new URLSearchParams(WindowUtils.getUrlSearch());
          if (this.refetchUserAfterRedirect) {
            params.set('reload-user', 'true');
          }
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore disable TS check as size has not yet been added to the URLSearchParams type: https://github.com/microsoft/TypeScript/issues/54466
          if (params.size > 0) {
            url += `?${params.toString()}`;
          }
          WindowUtils.redirect(url);
        }
      });
    } else {
      let source;
      if (this.args.source) {
        source = this.args.source;
      } else if (plan.token === this.appointmentsSubscription.planToken) {
        source = 'appts-resubscribe';
      } else {
        source = 'appts-manage';
      }
      if (this.appointmentsSubscription.merchantToken) {
        this.appointmentsSubscription.redirectToSubscriptionPage({
          unitToken: this.appointmentsSubscription.merchantToken,
          source,
          selectedPlanToken: plan.token,
          planGroupToken: 'appointments-group'
        });
      }
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "appointmentsFeatureInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "appointmentsSubscription", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "appointmentsSubscriptionModal", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isComparePlansModalOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "showSubsPlans", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "selectedPlan", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "canSubscribeInSituation", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "selectPlanHandler", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectPlanHandler"), _class.prototype), _class);
export { AppointmentsSubsPlansComponent as default };